(() => {
  const SELECTORS = {
    matrix: "[data-wholesale-matrix]",
    json: "[data-wholesale-variants-json]",
    body: "[data-wholesale-matrix-body]",
    msg: "[data-wholesale-matrix-msg]",
    addBtn: "[data-wholesale-add-all]",
    // Dawn's canonical "selected variant id" field is name="id" (select or hidden input)
    variantIdInput: '[name="id"]'
  };

  const SIZE_ORDER = [
    "XXS","XS","XS/S","S","S/M","M","M/L","L","L/XL","XL","XL/XXL","XXL","2XL","3XL","4XL","5XL",
    "ONE SIZE","OS","O/S"
  ];

  function normalizeSizeLabel(s) {
    return String(s || "")
      .trim()
      .toUpperCase()
      .replace(/\s+/g, " ");
  }

  function sizeRank(label) {
    const clean = normalizeSizeLabel(label);
    const idx = SIZE_ORDER.indexOf(clean);
    return idx === -1 ? 9999 : idx;
  }

  function parseJSONScript(el) {
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // You already changed this to 10+. (If you want 20+, change 10 to 20)
  function inventoryText(v) {
    if (!v.inventory_management) return "—";
    if (!v.available) return "0 (Sold out)";
    if (v.inventory_quantity === null || v.inventory_quantity === undefined) return "—";

    const qty = Number(v.inventory_quantity);
    if (!Number.isFinite(qty)) return "—";

    return qty >= 10 ? "10+" : String(qty);
  }

  function findClosestProductForm(matrixEl) {
    const section = matrixEl.closest(".shopify-section") || matrixEl.closest("section") || document;
    return section.querySelector("form[id^='product-form-']") || section.querySelector("form[action*='/cart/add']");
  }

  function getSelectedVariantId(formEl) {
    if (!formEl) return null;
    const idEl = formEl.querySelector(SELECTORS.variantIdInput);
    if (!idEl) return null;
    const val = idEl.value;
    const num = Number(val);
    return Number.isFinite(num) ? num : null;
  }

  function getSelectedColor(data, selectedVariantId) {
    if (!data || !data.variants || !selectedVariantId) return null;
    const v = data.variants.find(x => Number(x.id) === Number(selectedVariantId));
    return v ? v.option1 : null; // option1 = Colour
  }

  function clearBody(tbody) {
    while (tbody.firstChild) tbody.removeChild(tbody.firstChild);
  }

  function setMessage(msgEl, text, status) {
    if (!msgEl) return;
    msgEl.textContent = text || "";
    if (status) msgEl.setAttribute("data-status", status);
    else msgEl.removeAttribute("data-status");
  }

  function renderRows(matrixEl, data, selectedColor) {
    const tbody = matrixEl.querySelector(SELECTORS.body);
    const msg = matrixEl.querySelector(SELECTORS.msg);
    if (!tbody || !msg) return;

    const colourSpan = matrixEl.querySelector("[data-wholesale-selected-colour]");
    if (colourSpan) colourSpan.textContent = selectedColor ? selectedColor : "this colour";

    clearBody(tbody);
    setMessage(msg, "", null);

    if (!selectedColor) {
      setMessage(msg, "Select a colour to order by size.", "info");
      return;
    }

    const rows = data.variants
      .filter(v => v.option1 === selectedColor)
      .sort((a, b) => {
        const ra = sizeRank(a.option2);
        const rb = sizeRank(b.option2);
        if (ra !== rb) return ra - rb;
        return normalizeSizeLabel(a.option2).localeCompare(normalizeSizeLabel(b.option2));
      });

    if (!rows.length) {
      setMessage(msg, `No sizes found for ${selectedColor}.`, "info");
      return;
    }

    rows.forEach(v => {
      const disabled = !v.available;
      const tr = document.createElement("tr");

      tr.innerHTML = `
        <td>${v.option2 || ""}</td>
        <td>${inventoryText(v)}</td>
        <td>
          <input
            type="number"
            min="0"
            step="1"
            inputmode="numeric"
            ${disabled ? "disabled" : ""}
            data-variant-id="${v.id}"
            class="field__input"
            style="max-width: 110px;"
            placeholder="0"
          />
        </td>
      `;

      tbody.appendChild(tr);
    });
  }

  async function addItems(items) {
  const cartDrawer = document.querySelector('cart-drawer');
  
  // Get sections needed for the UI update
  const sections = cartDrawer ? cartDrawer.getSectionsToRender().map((section) => section.id) : ['cart-drawer', 'cart-icon-bubble'];

  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-Requested-With": "xmlhttprequest"
    },
    body: JSON.stringify({ 
      items,
      sections: sections.join(',') 
    })
  });

  const responseData = await res.json();

  if (!res.ok) {
    throw new Error(responseData?.description || "Failed to add to cart.");
  }

  if (cartDrawer && responseData.sections) {
    // Remove empty-state styling without triggering the drawer to open
    cartDrawer.classList.remove('is-empty');
    const drawerInner = cartDrawer.querySelector('.drawer__inner');
    if (drawerInner) drawerInner.classList.remove('is-empty');

    // Manually refresh the drawer's content (same sections Dawn would refresh),
    // but skip the auto-open behaviour renderContents() normally triggers
    if (typeof cartDrawer.getSectionsToRender === 'function') {
      cartDrawer.productId = responseData.id;
      cartDrawer.getSectionsToRender().forEach((section) => {
        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!sectionElement) return;
        sectionElement.innerHTML = cartDrawer.getSectionInnerHTML(
          responseData.sections[section.id],
          section.selector
        );
      });
    }
  }

  return responseData;
}

  function initMatrix(matrixEl) {
    const dataScript = matrixEl.querySelector(SELECTORS.json);
    const data = parseJSONScript(dataScript);
    if (!data) return;

    const formEl = findClosestProductForm(matrixEl);
    const btn = matrixEl.querySelector(SELECTORS.addBtn);
    const msg = matrixEl.querySelector(SELECTORS.msg);

    function rerender() {
      const variantId = getSelectedVariantId(formEl);
      const color = getSelectedColor(data, variantId);
      renderRows(matrixEl, data, color);
    }

    // Initial render
    rerender();

    // Re-render whenever something inside the product form changes
    if (formEl) {
      formEl.addEventListener("change", rerender);
      formEl.addEventListener("click", () => {
        window.requestAnimationFrame(rerender);
      });
    }

    // Also listen for Dawn's common pubsub event if present (safe no-op if not)
    if (window.PubSub && typeof window.PubSub.subscribe === "function") {
      try {
        window.PubSub.subscribe("variant:change", rerender);
        window.PubSub.subscribe("option:change", rerender);
      } catch (_) {}
    }

    // Add all button
    if (btn) {
  btn.addEventListener("click", async () => {
    // Save original button text
    const originalText = btn.textContent;
    setMessage(msg, "", null);

    const inputs = matrixEl.querySelectorAll("input[data-variant-id]");
    const items = [];

    inputs.forEach(inp => {
      const qty = parseInt(inp.value, 10);
      if (!Number.isNaN(qty) && qty > 0) {
        items.push({
          id: Number(inp.getAttribute("data-variant-id")),
          quantity: qty
        });
      }
    });

    if (!items.length) {
      setMessage(msg, "Enter quantities for at least one size.", "error");
      return;
    }

    btn.disabled = true;
    btn.textContent = "Adding..."; // Feedback 1: Loading state

    try {
      await addItems(items);

      // Clear fields
      inputs.forEach(inp => (inp.value = ""));

      // Feedback 2: Success state
      btn.textContent = "✓ Added to Cart";
      btn.classList.add('button--success'); // You can style this in CSS if you like

      // Reset button after 2 seconds
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
        btn.classList.remove('button--success');
      }, 2000);
    
    } catch (err) {
      console.error(err);
      btn.textContent = "Error!";
      setMessage(msg, err.message || "Error adding to cart.", "error");
      
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 3000);
    }
  });
}
  }

  function boot() {
    document.querySelectorAll(SELECTORS.matrix).forEach(initMatrix);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();